import { Metamodel } from 'app/model/base/model';
import { AzurePostgreSQLSink } from 'app/model/pipeline/copysink/azure-postgre-sql.copysink';
import { AzureHorizonDBTableDataset } from 'app/model/dataset/azure-horizon-db-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * Azure HorizonDB is PostgreSQL wire-compatible, so its copy sink reuses the exact same
 * serialization shape and behavior as the Azure Database for PostgreSQL copy sink (including the
 * write-method options). It is modeled as its own copy-sink type ('AzureHorizonDBSink') bound to
 * the HorizonDB dataset.
 */
@Metamodel.model({
    name: adfModelTypeMap.azureHorizonDb.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(AzureHorizonDBTableDataset)] }
})
export class AzureHorizonDBSink extends AzurePostgreSQLSink {
}
